import { useAuth, usePracticeAccess } from '@hb/react'
import {
  AdminPracticeData,
  getPracticeWithAdmin,
  MIDWIVES,
  MIDWIVES_ADMIN,
  Practice,
  practiceAdminRoles,
} from '@hb/shared'
import { useMemo } from 'react'
import { useDocument } from '../../../backend/db/hooks/useDocument'

export const usePractice = (practiceId: string | null) => {
  const { accessLevel } = useAuth()

  const { practiceAccess } = usePracticeAccess()

  const {
    data: publicData,
    loading,
    error: publicError,
  } = useDocument<Practice>(MIDWIVES, practiceId)

  const adminPracticeId = useMemo(() => {
    if (accessLevel === 'admin') return practiceId
    const practiceRole = practiceId ? practiceAccess?.[practiceId] : null
    if (practiceRole && practiceAdminRoles.includes(practiceRole)) return practiceId
    return null
  }, [accessLevel, practiceId, practiceAccess])

  const {
    data: adminData,
    loading: adminLoading,
    error: adminError,
  } = useDocument<AdminPracticeData>(MIDWIVES_ADMIN, adminPracticeId)

  const data = useMemo(() => {
    if (!publicData) return null
    return getPracticeWithAdmin(publicData, adminData ?? undefined)
  }, [publicData, adminData])

  return {
    loading: loading || adminLoading,
    error: publicError || adminError,
    data,
  }
}
